import React, { Fragment, useState, useEffect } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faPrint } from "@fortawesome/free-solid-svg-icons";

const NoteListActions = ({ data,Callback,printClinicNotes }) => {

  const deleteNote = async (id_hist_nota_clin) => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'notas-clinicas/delete', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body:JSON.stringify({id_hist_nota_clin:id_hist_nota_clin})
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        console.log(response);
        Callback();
      }
      else {
        alert("Ha ocurrido un error en el servidor");
      }
    })
      .catch(err => {
        console.log(err);
      })
  }

  return (
    <Fragment>
      <td role="cell">
        <Tooltip title="Eliminar Nota">
          <IconButton
            aria-label="delete-note"
            onClick={() => {
              deleteNote(data.data.original.id_hist_nota_clin);
            }}
          >
            <FontAwesomeIcon icon={faTrashAlt} />
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Imprimir Nota">
          <IconButton
            aria-label="print-note"
            onClick={() => {
              printClinicNotes(data.data.original.id_hist_nota_clin);
            }}
          >
            <FontAwesomeIcon icon={faPrint} />
          </IconButton>
        </Tooltip>
      </td>
    </Fragment>)
}

export default NoteListActions;
